// redux/actions/Companyactions.js

export const UPDATE_COMPANY = 'UPDATE_COMPANY';

export const GET_COMPANY_REQUEST = 'GET_COMPANY_REQUEST';
export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS';
export const GET_COMPANY_FAIL = 'GET_COMPANY_FAIL';

export const GET_COMPANY_BY_CODE_REQUEST = 'GET_COMPANY_BY_CODE_REQUEST';
export const GET_COMPANY_BY_CODE_SUCCESS = 'GET_COMPANY_BY_CODE_SUCCESS';
export const GET_COMPANY_BY_CODE_FAIL = 'GET_COMPANY_BY_CODE_FAIL';

export const GET_ALL_COMPANIES_REQUEST = 'GET_ALL_COMPANIES_REQUEST';
export const GET_ALL_COMPANIES_SUCCESS = 'GET_ALL_COMPANIES_SUCCESS';
export const GET_ALL_COMPANIES_FAIL = 'GET_ALL_COMPANIES_FAIL';

export const CREATE_COMPANY_REQUEST = 'CREATE_COMPANY_REQUEST';
export const CREATE_COMPANY_SUCCESS = 'CREATE_COMPANY_SUCCESS';
export const CREATE_COMPANY_FAIL = 'CREATE_COMPANY_FAIL';

export const UPDATE_COMPANY_REQUEST = 'UPDATE_COMPANY_REQUEST';
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';
export const UPDATE_COMPANY_FAIL = 'UPDATE_COMPANY_FAIL';

export const DELETE_COMPANY_REQUEST = 'DELETE_COMPANY_REQUEST';
export const DELETE_COMPANY_SUCCESS = 'DELETE_COMPANY_SUCCESS';
export const DELETE_COMPANY_FAIL = 'DELETE_COMPANY_FAIL';

export const SET_COMPANY_LOADING = 'SET_COMPANY_LOADING';

export const GET_HOLIDAYS_REQUEST = "GET_HOLIDAYS_REQUEST";
export const GET_HOLIDAYS_SUCCESS = "GET_HOLIDAYS_SUCCESS";
export const GET_HOLIDAYS_FAIL = "GET_HOLIDAYS_FAIL";
export const SET_HOLIDAYS_LOADING = "SET_HOLIDAYS_LOADING";

// ========================================
// 🎬 ACTION CREATORS
// ========================================



/// holidays


export const getHolidaysRequest = (year, country = "MA") => ({
    type: GET_HOLIDAYS_REQUEST,
    payload: { year: Number(year), country },
});

export const getHolidaysSuccess = (data) => ({
    type: GET_HOLIDAYS_SUCCESS,
    payload: data,
});

export const getHolidaysFail = (error) => ({
    type: GET_HOLIDAYS_FAIL,
    error,
});

export const setHolidaysLoading = (loading) => ({
    type: SET_HOLIDAYS_LOADING,
    payload: loading,
});

export const updateCompany = (company) => ({
    type: UPDATE_COMPANY,
    company
});

// --- Récupérer une société par ID ---
export const getCompanyRequest = (companyId) => ({
    type: GET_COMPANY_REQUEST,
    payload: { companyId }
});

export const getCompanySuccess = (company) => ({
    type: GET_COMPANY_SUCCESS,
    payload: company
});

export const getCompanyFail = (error) => ({
    type: GET_COMPANY_FAIL,
    error
});

// --- Récupérer une société par code ---
export const getCompanyByCodeRequest = (code) => ({
    type: GET_COMPANY_BY_CODE_REQUEST,
    payload: { code }
});

export const getCompanyByCodeSuccess = (company) => ({
    type: GET_COMPANY_BY_CODE_SUCCESS,
    payload: company
});

export const getCompanyByCodeFail = (error) => ({
    type: GET_COMPANY_BY_CODE_FAIL,
    error
});

// --- Récupérer toutes les sociétés ---
export const getAllCompaniesRequest = () => ({
    type: GET_ALL_COMPANIES_REQUEST
});

export const getAllCompaniesSuccess = (companies) => ({
    type: GET_ALL_COMPANIES_SUCCESS,
    payload: companies
});

export const getAllCompaniesFail = (error) => ({
    type: GET_ALL_COMPANIES_FAIL,
    error
});

// --- Créer une société ---
export const createCompanyRequest = (companyData, history) => ({
    type: CREATE_COMPANY_REQUEST,
    payload: companyData,
    history
});

export const createCompanySuccess = (company) => ({
    type: CREATE_COMPANY_SUCCESS,
    payload: company
});

export const createCompanyFail = (error) => ({
    type: CREATE_COMPANY_FAIL,
    error
});

// --- Mettre à jour une société ---
export const updateCompanyRequest = (companyId, companyData) => ({
    type: UPDATE_COMPANY_REQUEST,
    payload: { companyId, companyData }
});

export const updateCompanySuccess = (company) => ({
    type: UPDATE_COMPANY_SUCCESS,
    payload: company
});

export const updateCompanyFail = (error) => ({
    type: UPDATE_COMPANY_FAIL,
    error
});

// --- Supprimer une société ---
export const deleteCompanyRequest = (companyId, history) => ({
    type: DELETE_COMPANY_REQUEST,
    payload: { companyId },
    history
});

export const deleteCompanySuccess = (companyId) => ({
    type: DELETE_COMPANY_SUCCESS,
    payload: { companyId }
});

export const deleteCompanyFail = (error) => ({
    type: DELETE_COMPANY_FAIL,
    error
});

// --- Loading ---
export const setCompanyLoading = (loading) => ({
    type: SET_COMPANY_LOADING,
    payload: loading
});
